export default "src/content/themes/association-wordpress-theme/img/3ea6d0a871b2073ccf475a503e8d3df2.png";